module.exports = __webpack_public_path__ + "static/media/logo.14a012b0.svg";